import { mediaQueryUp } from 'components/utils/breakpoint'
import Modal from 'LuxKit/Modal/Modal'
import LineDollarAltIcon from 'LuxKit/Icons/line/LineDollarAltIcon'
import LineLanguageIcon from 'LuxKit/Icons/line/LineLanguageIcon'
import TabButton from 'LuxKit/Tabs/TabButton'
import TabButtonsGroup from 'LuxKit/Tabs/TabButtonsGroup'
import { rem } from 'polished'
import { useState } from 'react'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import NavBarLanguageItems from './NavBarLanguageItems'
import NavBarRegionItems from './NavBarRegionItems'

const Content = styled.div`
  padding-top: ${rem(8)};
`

export const NavBarCurrencyLanguageDialog = styled(Modal)`
  ${mediaQueryUp.tablet} {
    &&& {
      --nav-bar-currency-language-dialog-size: min(
        calc(100vw - ${rem(40)}),
        calc(100dvh - ${rem(40)}),
        ${rem(560)}
      );

      width: var(--nav-bar-currency-language-dialog-size) !important;
      max-width: var(--nav-bar-currency-language-dialog-size) !important;
      height: var(--nav-bar-currency-language-dialog-size) !important;
      max-height: var(--nav-bar-currency-language-dialog-size) !important;
    }
  }
`

interface Props {
  onSelect?: React.MouseEventHandler<HTMLButtonElement>
  showLanguageTab: boolean
}

function NavBarCurrencyLanguageModal(props: Props) {
  const { onSelect, showLanguageTab } = props
  const [activeTab, setActiveTab] = useState<'currency' | 'language'>('currency')

  return <>
    {showLanguageTab && <TabButtonsGroup fit="grow">
      <TabButton
        size="small"
        isActive={activeTab === 'currency'}
        startIcon={<LineDollarAltIcon />}
        onClick={() => setActiveTab('currency')}
      >
        <FormattedMessage
          id="5IzESyiJhZD7FXx2DaTM"
          defaultMessage="Region & Currency"
          description="Tab label for region and currency selection in the language and currency modal"
        />
      </TabButton>
      <TabButton
        size="small"
        isActive={activeTab === 'language'}
        startIcon={<LineLanguageIcon />}
        onClick={() => setActiveTab('language')}
      >
        <FormattedMessage
          id="_eRiayfEzUbUZ4Bbpv7r"
          defaultMessage="Language"
          description="Tab label for language selection in the language and currency modal"
        />
      </TabButton>
    </TabButtonsGroup>}
    <Content>
      {activeTab === 'currency' && <NavBarRegionItems onRegionSelect={onSelect} />}
      {activeTab === 'language' && showLanguageTab && <NavBarLanguageItems onLanguageSelect={onSelect} />}
    </Content>
  </>
}

export default React.memo(NavBarCurrencyLanguageModal)
